import { Component, computed, input } from "@angular/core";

import { AdaaHelper } from "../../core/utils";
import { CountUpDirective } from "../directives/count-up-directive";

@Component({
  imports: [CountUpDirective],
  selector: "adaa-count-up",
  styles: `
    :host {
      font-size: var(--count-up-var);
    }
    span {
      font-variant-ligatures: historical-ligatures;
    }
  `,
  template: `<span
    [style.--count-up-var]="fontSize()"
    [adaaCountUp]="value()"
    [suffix]="suffix()"
    [decimalPlaces]="decimals()"
  ></span>`,
})
export class CountUpComponent {
  total = input.required<number>();
  symbol = input<"%" | "N" | "C">("%");
  decimalPlaces = input<number>(2);
  fontSize = input<string>("2rem");

  readonly value = computed<number>(() => {
    if (this.symbol() !== "C") return this.total();

    return AdaaHelper.amountToString(this.total()) ?? this.total();
  });

  readonly suffix = computed<string>(() => {
    switch (this.symbol()) {
      case "%": {
        return "%";
      }
      case "C": {
        return " " + AdaaHelper.getCurrencySymbol(this.total(), true);
      }
      default: {
        return "";
      }
    }
  });

  readonly decimals = computed<number>(() => (this.symbol() === "%" ? this.decimalPlaces() : 0));
}
